/**
 * Copyright (c) 2021 - 2022, Kodit Doo
 * Created by kodit-marko on 11/29/22
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { FileParameter, RacuniClient, XmlRacuna } from '@kodit/core/data-api';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef, FileUploadService } from '@kodit/core/shared-ui';
import { finalize } from 'rxjs/operators';
import { AlertService } from '@kodit/core/services';

@Component({
  selector: 'kodit-racun-upload-form',
  templateUrl: './racun-upload-form.html',
  styleUrls: ['./racun-upload-form.scss'],
})
export class RacunUploadFormComponent implements OnInit, OnDestroy {
  readonly MAX_FILE_SIZE: number = 10000000;

  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  uploadCompleted: boolean;
  dropdownItems: SelectItem[];
  miniForm: FormGroup;

  constructor(
    private _cilent: RacuniClient,
    private _fb: FormBuilder,
    private _uploadService: FileUploadService,
    private _dialogRef: DynamicDialogRef,
    private _alertService: AlertService
  ) {}

  ngOnInit() {
    this._initForm();
    this._initDropdown();
    this._uploadService.setMaxAttachmentSize = this.MAX_FILE_SIZE;
  }

  handleUpload(files: File[]) {
    this.uploadCompleted = false;
    const filesRequest: FileParameter[] = [];
    files.forEach((file) => {
      filesRequest.push({
        data: file,
        fileName: file.name,
      });
    });

    this._subs = this._cilent
      .importXml(
        filesRequest,
        this.miniForm.value.xml,
        //this.miniForm.value.praviloSerijskogBrojaId,
        this.miniForm.value.memorandumId,
        this.miniForm.value.tekuciRacunId
      )
      .pipe(
        finalize(() => {
          this.uploadCompleted = true;
        })
      )
      .subscribe((res) => {
        this._dialogRef.close(res.data);
        this._alertService.addSuccessMsgs(res.messages);
      });
  }

  private _initForm() {
    this.miniForm = this._fb.group({
      xml: new FormControl(XmlRacuna.UBL),
      //praviloSerijskogBrojaId: new FormControl(),
      memorandumId: new FormControl(),
      tekuciRacunId: new FormControl(),
    });
  }

  private _initDropdown() {
    this.dropdownItems = [
      { label: 'UBL 2.1', value: XmlRacuna.UBL },
      { label: 'Altova', value: XmlRacuna.ALTOVA },
    ];
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
